<script lang="ts">
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
</script>

<div class="flex flex-col gap-2" data-testid="costs-skeleton">
	<SkeletonBlock width="100px" height="24px" />
	<SkeletonBlock width="100%" height="68px" borderRadius="0" />
	<div class="flex flex-col pt-4 gap-1">
		<SkeletonText minWords={1} maxWords={1} minWordLength={38} maxWordLength={42} />
		<div class="flex flex-row gap-1">
			<SkeletonBlock width="50%" height="32px" borderRadius="0" />
			<SkeletonBlock width="50%" height="32px" borderRadius="0" />
		</div>
		<div class="flex justify-between">
			<SkeletonText minWords={1} maxWords={1} minWordLength={18} maxWordLength={22} />
			<SkeletonText minWords={1} maxWords={1} minWordLength={6} maxWordLength={24} />
		</div>
		<div class="flex justify-between">
			<SkeletonText minWords={1} maxWords={1} minWordLength={12} maxWordLength={20} />
			<SkeletonText minWords={1} maxWords={1} minWordLength={8} maxWordLength={16} />
		</div>
		<div class="flex justify-between">
			<SkeletonText minWords={1} maxWords={1} minWordLength={18} maxWordLength={22} />
			<SkeletonText minWords={1} maxWords={1} minWordLength={6} maxWordLength={24} />
		</div>
	</div>
	<div class="flex flex-col pt-4 gap-1">
		<SkeletonText minWords={1} maxWords={1} minWordLength={38} maxWordLength={42} />
		<div class="flex justify-between">
			<SkeletonText minWords={1} maxWords={1} minWordLength={18} maxWordLength={22} />
			<SkeletonText minWords={1} maxWords={1} minWordLength={6} maxWordLength={24} />
		</div>
		<div class="flex justify-between">
			<SkeletonText minWords={1} maxWords={1} minWordLength={12} maxWordLength={20} />
			<SkeletonText minWords={1} maxWords={1} minWordLength={8} maxWordLength={16} />
		</div>
	</div>
	<div class="flex flex-col pt-4 gap-1">
		<SkeletonText minWords={1} maxWords={1} minWordLength={32} maxWordLength={38} />
		<SkeletonBlock width="100%" height="68px" borderRadius="0" />
	</div>
</div>
